import { render, staticRenderFns } from "./Segmentos.vue?vue&type=template&id=76a7a81d&scoped=true&"
import script from "./Segmentos.vue?vue&type=script&lang=js&"
export * from "./Segmentos.vue?vue&type=script&lang=js&"
import style0 from "./Segmentos.vue?vue&type=style&index=0&id=76a7a81d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7a81d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
